import { render, staticRenderFns } from "./Identifier.vue?vue&type=template&id=346421cd&scoped=true&lang=pug&"
import script from "./Identifier.vue?vue&type=script&lang=js&"
export * from "./Identifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346421cd",
  null
  
)

export default component.exports